import React from 'react'

function UniRes() {
  return (
      <div style={{ padding: '50px', fontSize: '15px' }}>
          <p>
              تشمل المهتمين الراغبين بالاستقرار في السعودية لمدة
              <br />
              محدودة أو غير محدودة.
              <br />
              <br />
              لقد أنعم الله على السعودية بمقومات حضارية، اجتماعية،
              <br />
              ديموغرافية، اقتصادية، وجغرافية، وهو ما يجعلها مقصداً 
              <br />
              للراغبين بالاستقرار في أجواء مليئة بالتسامح وغنية بالفرص.
              <br />
              <br />
              وتهدف إقامة مميزة غير محددة المدة ومحددة المدة إلى تمكين
              <br />
              المستفيدين الراغبين بالاستقرار في السعودية، عبر توفير بيئة 
              <br />
              ملائمة تضم مجموعة من المزايا.
              <br />
              <br />
              <span style={{ fontWeight: "bolder" }}>المزايا العامة:</span>
              <br />
              الإقامة في السعودية مع الأسرة، والتي تشمل الوالدين والأزواج 
              <br />
              والأبناء الذين تقل أعمارهم عن 25 عامًا.
              <br />
              الانتقال من منشأة إلى أخرى بحرية.
              <br />
              الإعفاء من المقابل المالي المقرر على الوافدين والمرافقين.
              <br />
              خروج حامل الإقامة المميزة وأفراد أسرته من السعودية والعودة
              <br />
              إليها دون اشتراط تأشيرة.
              <br />
              صدار تأشيرات زيارة للأقارب.
              <br />
              استخدام المسارات المُخصصة للمواطنين ومواطني دول مجلس
              <br />
              التعاون في المنافذ.
              <br />
              العمل في منشآت القطاع الخاص والانتقال بينها للزوج والزوجة 
              <br />
              والأبناء
              <br />
              مزاولة الأعمال التجارية وفقًا لنظام الاستثمار.
              <br />
              تملُّك العقارات والانتفاع بها.
              <br />
              معايير الأهلية:
              <br />
              تقديم ما يثبت الملاءة المالية للمتقدم
              <br />
              <br/>
              <span style={{ fontWeight: "bolder" }}>❖ جميع الشروط قابلة للتغيير</span>
              <br />
              مدة الإقامة:
              <br />
              لإقامة المميزة المحددة: إقامة محددة لسنة واحدة وحتى
              <br />
              5 سنوات، قابلة للتجديد.
              <br />
              <br />
              الإقامة المميزة غير محددة المدة : إقامة دائمة.
              <br />
              <br />
              <span style={{ fontWeight: "bolder" }}>المقابل المالي:</span>
              <br />
              الإقامة المميزة المحددة: 100,000 ريال سعودي لكل سنة، 
              <br />
              مع تخفيض بنسبة (2%) لكل سنة وبصورة تراكمية عند التقديم
              <br />
              على أكثر من سنة.
              <br/>
              <br />
              الإقامة المميزة غير محددة المدة: 800,000 ريال سعودي.
          </p>
      </div>
  )
}

export default UniRes